import { useModel } from '@umijs/max';
import { useEffect } from 'react';
import { postAccessHeartbeat } from '@/services/access/api';
import { getSessionId, getToken, saveSessionId } from '@/services/auth/wecom';

const INTERVAL_MS = 60_000;

/**
 * 登录后周期性心跳，用于在线状态与在线时长累计。
 */
const AccessHeartbeat: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const user = initialState?.currentUser;

  useEffect(() => {
    if (!user?.userid && !user?.name) return;
    if (!getToken()) return;

    let stopped = false;

    const beat = async () => {
      if (stopped || document.visibilityState === 'hidden') return;
      try {
        const res = await postAccessHeartbeat(getSessionId() || undefined);
        if (res?.data?.sessionId) saveSessionId(res.data.sessionId);
      } catch {
        // ignore
      }
    };

    void beat();
    const timer = window.setInterval(beat, INTERVAL_MS);
    const onVis = () => {
      if (document.visibilityState === 'visible') void beat();
    };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      stopped = true;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [user?.userid, user?.name]);

  return null;
};

export default AccessHeartbeat;
